import {
  PAPERWORK,
  PAPERWORK_COMPLETE_VISIT_DETAILS,
  PAPERWORK_INSURANCE_DETAILS,
  PAPERWORK_VISIT_DETAILS,
  PAPERWORK_GUARANTOR_INFORMATION,
  PAPERWORK_PRIMARY_CARE_PROVIDER,
  PAPERWORK_SIGN_CONSENT,
  PAPERWORK_SUBMIT,
  PAPERWORK_COMPLETE_YOUR_PROFILE,
  PAPERWORK_PREFERRED_PHARMACY,
  PAPERWORK_ADDITIONAL_INFORMATION,
} from '../../constants/routes';

export const getPaperworkFormSteps = ({
  id,
  requestContactInfo,
  isConsentsSigned,
  includesAdditionalInfoQuestions,
  skipInsurance,
}) => [
  ...(skipInsurance
    ? []
    : [`${PAPERWORK}/${id}/${PAPERWORK_INSURANCE_DETAILS}`]),
  ...(requestContactInfo
    ? [`${PAPERWORK}/${id}/${PAPERWORK_COMPLETE_YOUR_PROFILE}`]
    : []),
  `${PAPERWORK}/${id}/${PAPERWORK_GUARANTOR_INFORMATION}`,
  `${PAPERWORK}/${id}/${PAPERWORK_PREFERRED_PHARMACY}`,
  `${PAPERWORK}/${id}/${PAPERWORK_PRIMARY_CARE_PROVIDER}`,
  ...(includesAdditionalInfoQuestions
    ? [`${PAPERWORK}/${id}/${PAPERWORK_ADDITIONAL_INFORMATION}`]
    : []),
  ...(isConsentsSigned ? [] : [`${PAPERWORK}/${id}/${PAPERWORK_SIGN_CONSENT}`]),
  `${PAPERWORK}/${id}/${PAPERWORK_SUBMIT}`,
];

export const getAllPaperworkSteps = ({
  id,
  requestContactInfo,
  isConsentsSigned,
  includesAdditionalInfoQuestions,
  skipInsurance,
}) => [
  `${PAPERWORK}/${id}/${PAPERWORK_VISIT_DETAILS}`,
  ...getPaperworkFormSteps({
    id,
    requestContactInfo,
    isConsentsSigned,
    includesAdditionalInfoQuestions,
    skipInsurance,
  }),
  `${PAPERWORK}/${id}/${PAPERWORK_COMPLETE_VISIT_DETAILS}`,
];



// WEBPACK FOOTER //
// ./src/utils/paperwork/getPaperworkRoutes.js